<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'
import { tableData } from '@router/views/pages/ui/tables/data-advanced'
import { downloadRequest } from '../downloadRequest'

export default {
  name: 'DatatableSearchSurcharge',
  props: {
    tableDatap: [Object, Array],
    typeTablep: String,
  },
  data() {
    return {
      typeTable: this.typeTablep,
      tableData: [{ data: 'ok' }],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'age',
      sortDesc: false,
      fields: [],
      fieldList: [{ key: 'data' }],
      excludeFields: [],
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length
    },
  },
  created() {
    this.updateTableFields('SELECT')
    // console.log(this.tableData)
    ;(this.typeTable = this.typeTablep), (this.tableData = this.tableDatap[0])
    this.fieldList = this.tableDatap[1]
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      //this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    customFilterTable(row, filter) {
      var valuesRow = Object.values(row)
      //console.log(values)
      let filtersSp = filter.split(' ')
      var flag = false
      const filtersFined = []
      filtersSp.forEach((filterVal) => {
        valuesRow.filter((valRow) => {
          var valRowLC = String(valRow).toLowerCase()
          var filterValLC = String(filterVal).toLowerCase()
          if (valRowLC.includes(filterValLC)) {
            if (!filtersFined.includes(filterVal)) filtersFined.push(filterVal)
          }
        })
      })

      if (filtersFined.length === filtersSp.length) {
        flag = true
      }

      if (flag === true) {
        return true
      } else {
        return false
      }
    },
    updateTableFields(action = 'SELECT') {
      if (action === 'SELECT') {
        axiosGetPost('post', 'settingU/', {
          modules: [this.typeTable + '_surcharge_search'],
        }).then((data) => {
          if (data.success === true) {
            this.excludeFields = data.data[this.typeTable + '_surcharge_search']
            this.orderFields()
          } else {
            this.$toastr.e('Error Load Exclude column Select' + data.error)
          }
          return data
        })
      } else if (action === 'UPDATE') {
        this.orderFields()
        axiosGetPost('put', 'settingU/', {
          modules: [
            {
              name: this.typeTable + '_surcharge_search',
              data: this.excludeFields,
            },
          ],
        }).then((data) => {
          if (data.success !== true) {
            this.$toastr.e('Error Load Exclude column Update' + data.error)
          }
          return data
        })
      }
    },
    orderFields() {
      this.fields = []
      for (var [key, value] of Object.entries(this.fieldList)) {
        if (!(this.excludeFields.indexOf(value.key) > -1)) {
          this.fields.push(this.fieldList[key])
        }
      }
    },
    downloadFileRequest(id) {
      downloadRequest(id, 'FCL')
    },
  },
}
</script>

<template>
  <div>
    <div class="form-group row">
      <div class="col-md-12">
        <div class="d-flex mb-md-2">
          <!-- Inicio Table */******************************************************* */ -->
          <div class="mr-auto">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Show&nbsp;
                <b-form-select
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select
                >&nbsp;entries
              </label>
            </div>
          </div>
          <!-- Inicio Ocultar columnsas /********************/**************-->
          <div>
            <b-dropdown
              class="d-inline"
              variant="link"
              toggle-class="font-weight-bold p-0 align-middle"
            >
              <template v-slot:button-content>
                Hide Columns
                <i class="uil uil-eye-slash font-size-16 align-middle"></i
                ><i class="uil uil-angle-down font-size-16 align-middle"></i>
              </template>
              <div v-for="(field, index) of fieldList" :key="index">
                <div v-if="field.checkBox" class="dropdown-item">
                  <div class="col-lg-6 mb-2 mb-lg-0">
                    <div
                      :for="`field-${index + '-' + typeTable + '_rate_search'}`"
                      class="custom-control custom-checkbox"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="`field-${
                          index + '-' + typeTable + '_rate_search'
                        }`"
                        :value="field.key"
                        v-model="excludeFields"
                        @change="updateTableFields('UPDATE')"
                      />
                      <label
                        class="custom-control-label"
                        :for="`field-${
                          index + '-' + typeTable + '_rate_search'
                        }`"
                        >{{ field.label }}</label
                      >
                    </div>
                    <!-- end checkbox -->
                  </div>
                </div>
              </div>
            </b-dropdown>
          </div>
          <!-- Fin Ocultar columnsas /********************/**************-->
          <!-- Search -->
          <div>
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-sm ml-2"
              ></b-form-input>
            </label>
          </div>

          <!-- End search -->
        </div>
        <!-- Table -->
        <div class="table-responsive mb-0">
          <b-table
            striped
            hover
            :items="tableData"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            :filter-function="customFilterTable"
            @filtered="onFiltered"
          >
            <template v-slot:cell(origin)="row">
             <span class="badge badge-soft-primary" :title="row.item.origin">Origin</span>
            </template>
            <template v-slot:cell(destiny)="row">
              <span class="badge badge-soft-success" :title="row.item.destiny">Destiny</span>
            </template>
            <template v-slot:cell(actions)="row">
              <button
                class="btn btn-sm my-0 btn-outline-primary"
                title="Download Request File"
                @click="downloadFileRequest(row.item.request_id)"
              >
                <i class="uil uil-cloud-download"></i>
              </button>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>

        <!-- Fin Table */******************************************************* */ -->
      </div>
    </div>
  </div>
</template>